
import { WDListItem } from './wd-list-item'
import WDFormProxy from '../form/wd-form-proxy'

export default class WDListFormItem extends WDListItem
{

	#form = null;

	constructor()
	{
		super().classList.add('wd-list-form-item');

		//remove the standard click event
		this.off('click');

		this.#form = new WDFormProxy();
		this.content = this.#form;
	
		return this;
	};

	set proxy(proxy) { this.#form.proxy = proxy; };
	get proxy() { return this.#form.proxy; };
	get form() { return this.#form; };

	add(formCfg)
	{
		/**
		 * BUG:
		 * moving the form inputs from the main form tag to within each cell 
		 * prevents us from pulling all the items by iterating through the children.
		 * We either need to rework how items works, or override it so it uses
		 * some other selector. This may also break serialization because the
		 * form can no longer find the input using getItem to update it...
		 */

		//just passed a regular element, add that instead
		//create a cell that we can add our form to
		const cell = super.add();

		return new Promise((resolve, reject) =>
		{
			if (formCfg instanceof HTMLElement) 
			{
				cell.append(formCfg);
				resolve(cell);
			}
			else
			{
				cell.classList.add(formCfg.name);
	
				this.#form.addForm(formCfg).then(formObj =>
				{
					cell.append(formObj);
					resolve(formObj);

				});
			}

		});

	};

	getItem(formName)
	{
		return this.#form.getItem(formName);
	};

	get value() { return this.#form.value; };
	set value(val) { this.#form.value = val; };

	req() { return this.#form.req(); };
	post() { return this.#form.post(); };
	del() { return this.#form.del(); };

};

customElements.define('wd-list-form-item', WDListFormItem);
